export type StatusTone = "new" | "active" | "claim" | "pending" | "locked" | "done" | "soon";

export function StatusTag({ label, tone = "active" }: { label: string; tone?: StatusTone }) {
  return <span className={`status-tag ${tone}`}>{label}</span>;
}
